import { AboutSectionProps } from "interfaces/ExternalPage/SpeakerLandingPage.interface";
import EventDescriptionEditor from "views/Admin/Events/EventDescriptionEditor";

export default function AboutSection({ bio }: AboutSectionProps) {
  return (
    <section className="w-full h-full">
      <div className="h-full">
        <h2 className="text-lg sm:text-xl font-monaMedium text-[#333333] mb-2">
          About me
        </h2>
        <div className="bg-[#F2ECE2] font-monaRegular space-y-4 text-[#353C46] leading-relaxed h-auto sm:h-[calc(100%-28px-8px)] rounded-2xl hover:shadow-md transition-shadow duration-300 p-4 sm:pl-[34px] sm:pt-[34px] sm:pr-[20px]">
          <EventDescriptionEditor description={bio || ""} />
        </div>
      </div>
    </section>
  );
}
